import React from 'react'

import { 
    Paper, Button, Box, Typography,
    Stack
} from '@mui/material'
import Pagination  from '../Pagination/Paginate'
import { getPaginate } from '../../services/utils'
//import { useNavigate } from 'react-router-dom'
import Search from '../Search'
import { formatFloatToPrice } from 'utils/price'
// import { useUser } from 'services/StateContext'
// import { useUser } from 'services/StateContext'
// import { useUser } from '../../services/StateContext'


const section = {
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: 80,
        minHeight: 80,
        width: '100%',
        padding: '5px',
        cursor: 'pointer',
        textAlign: 'center',
        alignContent: 'center',
        overflow: 'hidden',
        color: '#000',
        textOverflow: 'ellipsis',
    },
    text: {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }
} 

export const Section = ({item, selectItem, label}) => {
    
    if (!item) return null
    
    const id = item[label]
        ?.replaceAll(' ', '_')
        ?.toLowerCase()
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "") || ''

    const hasConvenio   = label.match(/convenio/gi)
    const name          = hasConvenio ? "convenio" : "especialidade"
    const attributeData = {[`data-${name}`]: item[label]?.toLowerCase()}

    return <Button
        component={Paper} 
        sx={section.button}
        elevation={4}
        onClick={() => { selectItem(item.data) } }
        id={id}
        {...attributeData}
        className={id +' '+ name}
    >
        <Stack flexDirection={'column'}>
            <Typography 
                sx={section.text}
                component={'p'} 
                variant={'blockquote'}
            > 
                {item?.data ? item?.data.map( d => d[label]).join(', ') : item[label]}
            </Typography> 

            <Typography 
                sx={section.text}
                component={'p'} 
                variant={'blockquote'}
            > 
                {item?.preco > 0 ? `R$ ${formatFloatToPrice(item?.preco)}` : ''}
            </Typography> 
        </Stack>

    </Button>    
    
}

export const ButtonBack = ({handleChildren}) => {
    
    const props = {
        component: Paper, 
        key: 'voltar',
        sx: {
            textAlign: 'center',
            height: 80,
            width: '100%',
            //lineHeight: '80px',
            whiteSpace: 'break-spaces',
            cursor: 'pointer',
            overflow: 'hidden',
            color: '#fff',
            bgcolor: '#0c1141',
            '&:hover': {
                bgcolor: '#41477d'
            }  
        },
    }

    const voltar = {
        name: 'redirect',
        elevation: 4,
        id: 'redirect',
        onClick: handleChildren,
        value: 'voltar',
        children: 'Voltar'
    } 

    const buttonProps = { ...props, ...voltar} 

    return <Button {...buttonProps} />
}

const Sections = ({ items, totalByPerPage, selectItem, input, Obs }) => {
    
    const [ dataFilter  , setDataFilter   ] = React.useState([])
    const [ data        , setData         ] = React.useState([])
    const [ count       , setCount        ] = React.useState(0)
    const [ page        , setPage         ] = React.useState(1)
    const [ children    , setChildren     ] = React.useState([])
    const [ childrenPage, setChildrenPage ] = React.useState(1)

    const handleData = React.useCallback(() => {
        
        const dataFiltered = () => {

            const withPaginate = getPaginate(dataFilter, totalByPerPage, page)
             
            setData(withPaginate) 
    
            // setDataFilter(items)
        
            setCount(Math.ceil(withPaginate.length / totalByPerPage))
        }

        const dataChildren = () => {

            const withPaginate = getPaginate(children, totalByPerPage, childrenPage)
             
            setData(withPaginate) 
    
            //setDataFilter(items)
        
            setCount(Math.ceil(children.length / totalByPerPage))
        }
    
        const dataTransform = () => {
            
            const withPaginate = getPaginate(items, totalByPerPage, page)
             
            setData(withPaginate) 
    
            setCount(Math.ceil(items.length / totalByPerPage))
        }
        
        if (children.length > 0) { 
            dataChildren() 
        } else if (dataFilter.length > 0) {
            dataFiltered()    
        }
        else {
           
            dataTransform()
        }

        
        // eslint-disable-next-line
    }, [items, page, dataFilter, childrenPage, totalByPerPage, children])
    
    const changePage = p => { 
        setPage(p)
        setChildrenPage(p) 
        setDataFilter([])
    }

    const handleSelect = (item, name) => {
        
        if (item?.data?.length < 2) {
            return selectItem(item.data[0])
        }

        if (item[name] !== undefined)  {
            return selectItem(item)
        }

        setChildren(item.data)
        setChildrenPage(1)
    }
    
    const handleChildren = () => {
        setChildren([])
        setChildrenPage(0)
        setPage(page)
    }

    React.useEffect( () => {
        handleData()
    }, [handleData])

    return <Box sx={{py: 2}} >
        
        <Search 
            items={items} 
            totalByPerPage={totalByPerPage} 
            handleSelect={handleSelect} 
            input={input}
        >
            <Box sx={{
                py: 2,
                bgcolor: 'background.default',
                display: 'grid',
                gridTemplateColumns: { md: `repeat(${totalByPerPage / 2}, 1fr)`, xs: '1fr 1fr' },
                gap: 2,
                wrap: 'no-wrap'
            }} >
                
                {data.length === 0 || children.length === 0 ? null : <ButtonBack handleChildren={handleChildren} />}
                {data.map((item, i) => <Section 
                        label={input.label}
                        selectItem={() => handleSelect(item, input.name)} 
                        item={item} 
                        key={i} 
                    /> 
                )}
                
            </Box>
            {Obs && <Obs />} 
            
            <Pagination 
                page={page}
                items={data} 
                totalByPerPage={totalByPerPage} 
                changePage={changePage}
                count={count} 
                boundaryCount={10}
            />
        </Search>
    </Box> 
}

export default Sections